/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Resetpasswordbutton2Inputs */

const zh_auth_resetpasswordbutton2 = /** @type {(inputs: Auth_Resetpasswordbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重置密码`)
};

const en_auth_resetpasswordbutton2 = /** @type {(inputs: Auth_Resetpasswordbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reset password`)
};

const es_auth_resetpasswordbutton2 = /** @type {(inputs: Auth_Resetpasswordbutton2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Restablecer contraseña`)
};

/**
* | output |
* | --- |
* | "Reset password" |
*
* @param {Auth_Resetpasswordbutton2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const auth_resetpasswordbutton2 = /** @type {((inputs?: Auth_Resetpasswordbutton2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Resetpasswordbutton2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_auth_resetpasswordbutton2(inputs)
	if (locale === "en") return en_auth_resetpasswordbutton2(inputs)
	return es_auth_resetpasswordbutton2(inputs)
});
export { auth_resetpasswordbutton2 as "auth_resetPasswordButton" }